<template>
    <div class="discover-more">
        <section class="section01">
            <div class="text sp_padding">
                <div class="headline">Discover More</div>
                <div class="title">International reporters<br> experience Japan Heritage</div>
                <div class="lead">
                    <p>The best way to fully appreciate the culture and history behind each Japan Heritage is to actually go there and experience it for yourself.</p>

                    <p>In this section, we asked reporters and writers from foreign media to visit Japan Heritage sites and share their experiences in their respective outlets. This time, japan-guide.com, a leading English travel website focusing on Japan, took  us up on our offer. Which Japan Heritage site did they visit?</p>
                </div>
            </div>
            <div class="layout-bg">
                <div class="movie">
                    <video-player :options="videoOptions"></video-player>
                </div>
            </div>
        </section>
        <section class="section02">
            <div class="group_title">
                <div class="inner">
                    <div class="text sp_padding">
                        <div class="headline">Discover More  No. 2</div>
                        <div class="title">Exploring the sake regions of Itami and Nada</div>
                    </div>
                    <div class="group_reporters sp_padding">
                        <div class="title">Reporters visiting Japan Heritage site</div>
                        <div class="group_card">
                            <div class="card">
                                <div class="img"><img src="./../../assets/discover_more2/reporter01.png" alt=""></div>
                                <div class="text">
                                    <div class="name">Raina Ong</div>
                                    <div class="introduction">japan-guide.com<br> editor,writer, photographer</div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="img"><img src="./../../assets/discover_more2/reporter02.png" alt=""></div>
                                <div class="text">
                                    <div class="name">Thomas Rönnlund</div>
                                    <div class="introduction">japan-guide.com<br>videographer</div>
                                </div>
                            </div>
                        </div>
                        <div class="group_information">
                            <div class="img"><img src="./../../assets/discover_more/logo_japanguide.png" alt=""></div>
                            <div class="text">A Japan travel guide geared towards English speakers, particularly in Europe, the US, and Australia.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="group">
                </div>
                <div class="group">
                </div>
                <div class="group">
                    <div class="text sp_padding">
                        Sake has been synonymous with the Itami and Nada regions in Hyogo Prefecture for centuries. Blessed with pristine water and locally harvested rice, we found that this production hub of fermented rice wine is home to many museums and breweries that keep sake' s history alive.
                    </div>
                    <div class="text sp_padding"></div>
                    <div class="layout-2column">
                        <div class="img">
                            <img src="./../../assets/discover_more2/FormerOkadaResidence.jpg" alt="">
                            <figcaption class="sp_padding">Former Okada Residence<br>(Itami City Museum of Art, History and Culture)</figcaption>
                        </div>
                        <div class="img">
                            <img src="./../../assets/discover_more2/ItamiOimatsuBrewingCompany.jpg" alt="">
                            <figcaption class="sp_padding">Itami Oimatsu Brewing Company</figcaption>
                        </div>
                    </div>
                    <div class="text sp_padding">
                        Our first stop was the Itami City Museum of Art, History and Culture, which contains the former Okada Residence, a well-preserved 17th-century merchant residence and sake brewery made with traditional construction techniques.
                    </div>
                    <div class="text sp_padding">
                        One sake brewrey in Itami has made its well water available to the public for free. We quenched our thirst here while lapping up the area' s sake history.
                    </div>
                    <div class="text sp_padding">
                        Konishi Brewing Company' s Shirayuki Brewery Village Chojugura featured authentic sake-production displays, and also served exquisitely paired local sake and dishes.
                    </div>
                </div>
                <div class="group">
                    <div class="layout-2column">
                        <div class="img">
                            <img src="./../../assets/discover_more2/KikumasamuneSakeBreweryMuseum.jpg" alt="">
                            <figcaption class="sp_padding">At Kiku-Masamune Sake Brewery Museum' s <br>Taru Sake Meister Factory</figcaption>
                        </div>
                        <div class="img">
                            <img src="./../../assets/discover_more2/SawanotsuruMuseum.jpg" alt="">
                            <figcaption class="sp_padding">Sawanotsuru Museum</figcaption>
                        </div>
                    </div>
                    <div class="text sp_padding">
                        In Nada, the Imazu Lighthouse built over 200 years ago still stood majestically, and Sawanotsuru Museum and the Kiku-Masamune Taru Sake Meister Factory both showcased their history of sake production. At the Meister factory we had the rare opportunity to watch craftsmen making traditional Yoshino-cedar sake barrels.
                    </div>
                </div>
                <div class="group">
                    <div class=" layout-bg">
                        <div class="image">
                            <img src="./../../assets/discover_more2/NadagogoSakedokoro.jpg" alt="">
                            <figcaption  class="sp_padding">The counter at Nadagogo Sakedokoro</figcaption>
                        </div>
                    </div>
                    <div class="text sp_padding">
                        Finally, at Nadagogo Sakedokoro, we sampled some of the region' s best-known sake.
                    </div>
                    <div class="text sp_padding">
                        We hope visitors from abroad also visit Itami and Nada and raise a glass to Japan' s rich sake culture and history.
                    </div>
                </div>
                <div class="author sp_padding">Written by: media tour crew accompanying japan-guide.com</div>
            </div>
            <a href="https://www.japan-guide.com/ad/sake-culture-itami-nada/" target="_blank" rel="noopener noreferrer">
                <div class="card_link">
                    <div class="text">
                        <div class="headline">japan-guide.com article</div>
                        <div class="title">Exploring the sake regions of Itami and Nada</div>
                    </div>
                    <div class="arrow"></div>
                </div>
            </a>
            <a href="https://www.youtube.com/watch?v=UQH-MihLzSQ" target="_blank" rel="noopener noreferrer">
                <div class="card_link">
                    <div class="text">
                        <div class="headline">japan-guide.com video</div>
                        <div class="title">Exploring the sake regions of Itami and Nada</div>
                    </div>
                    <div class="arrow"></div>
                </div>
            </a>
        </section>
        <section class="section04">
            <div class="inner">
                <h2>Other Articles</h2>
                <ul>
                    <li>
                        <router-link :to="{name: 'DiscoverMore1'}" target="_blank" rel="noopener noreferrer">
                            <div class="img"><img src="./../../assets/discover_more2/TomonouraOtherArticles.jpg" alt=""></div>
                            <div class="text">
                                <div class="headline">Experience the days of old in Tomonoura by the sea</div>
                                <div class="title">A 2-day itinerary in a historical port town</div>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </section>
<!--        追加依頼があれば、復活-->
<!--        <section class="section03">-->
<!--            <div class="inner">-->
<!--                <h2>Related links</h2>-->
<!--                <ul>-->
<!--                    <li>-->
<!--                        <a href="https://www.japan.travel/japan-heritage/popular/17aa9650-6f70-4ba9-84bf-41fe6c9f5434">-->
<!--                            <div class="img"><img src="./../../assets/discover_more/related-link01.jpg" alt=""></div>-->
<!--                            <div class="text">-->
<!--                                <div class="headline">More on this Japan Heritage</div>-->
<!--                                <div class="title">The Beautiful Old Port Town of Tomonoura</div>-->
<!--                            </div>-->
<!--                        </a>-->
<!--                    </li>-->
<!--                </ul>-->
<!--            </div>-->
<!--        </section>-->
    </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer/VideoPlayer";
export default {
    name: "DiscoverMore2",
    components: {VideoPlayer},
    created: function() {
        document.title = 'Discover More | Japan Heritage Official Site'
    },
    data: function () {
        return {
            videoOptions: {
                controls: true,
                preload: 'none',
                fluid: true,
                muted: false,
                poster: 'https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/DiscoverMore2.jpg',
                sources: [
                    {
                        src: "https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/streaks/discover_more_2.m3u8",
                    }
                ],
            }
        }
    },
}
</script>

<style src="./DiscoverMore2.scss" lang="scss" scoped>
body {
    font-family: 'Marcellus', serif !important;
}
</style>
